import React from 'react';
import { Stack } from '@mui/material';
import { RoomsAmount, RoomsAmountValues } from '../components/RoomsAmount';

import styles from './CalendarFooter.module.scss';

type Props = {
  roomsAmount: RoomsAmountValues | null;
};

export function CalendarFooter({ roomsAmount }: Props) {
  if (roomsAmount === null) {
    return null;
  }

  return (
    <Stack className={styles.container}>
      <RoomsAmount values={roomsAmount} direction="row" />
    </Stack>
  );
}
